import React from "react";
import { observer } from "mobx-react-lite";
import { useCreateLeagueMatchStore } from "../../../store/StoreContext";
import { TCText } from "../../../components/tcText/TCText";
import { CourtType } from "../../../types/types";
import { CourtZone } from "./CourtZone";

type props = {};

export const SelectCourtType: React.FC<props> = observer(() => {
  const createLeagueMatchStore = useCreateLeagueMatchStore();

  return (
    <div style={{ marginTop: 20 }}>
      <TCText
        style={{
          fontWeight: 500,
          fontSize: 12,
          color: "black",
          marginBottom: 10,
        }}
        value="Select court type"
      />
      <div
        style={{
          display: "flex",
          overflowX: "auto",
          gap: "10px", // Adds spacing between items
          scrollbarWidth: "none", // Hides scrollbar in Firefox
          msOverflowStyle: "none", // Hides scrollbar in IE
          whiteSpace: "nowrap", // Prevents wrapping
        }}>
        {createLeagueMatchStore.courts.map((court: CourtType) => (
          <CourtZone
            key={court.id}
            title={court.title}
            isSelected={court.id === createLeagueMatchStore.selectedCourt?.id}
            onPress={() => {
              createLeagueMatchStore.setSelectedCourt(court);
            }}
          />
        ))}
      </div>
    </div>
  );
});
